// assets/relocate-calc.js
// ------------------------------------------------------------
// Part 1: Relocate MachShip calculator under metas/wishlist
// ------------------------------------------------------------
(function () {
  'use strict';

  // Guard: run only on product pages (common body classes / markers)
  var body = document.body;
  var isProduct =
    body.classList.contains('template-product') ||
    body.classList.contains('product') ||
    document.querySelector('[data-product-template],[data-section-type="product"]');

  if (!isProduct) return; // Never run elsewhere

  // Utility: safely move a single calculator under its nearest metas/wishlist
  function moveOne(calc) {
    if (!calc || calc.__moved__) return false;

    // Find the "metas/wishlist" container that belongs to the same product area
    // Prefer the closest in the same section/modal, then fallback global
    var scope = calc.closest('[data-section-id], .Product, .product, .modal, .drawer') || document;
    var metas = scope.querySelector('.product-single__metas.wishlist') || document.querySelector('.product-single__metas.wishlist');
    if (!metas) return false;

    // If it's already right after metas, skip
    if (metas.nextElementSibling === calc) {
      calc.__moved__ = true;
      return true;
    }

    // Move and ensure it's visible
    metas.insertAdjacentElement('afterend', calc);
    calc.style.display = 'block';
    calc.__moved__ = true;
    return true;
  }

  // Try to move all calculators currently on the page
  function moveAll() {
    var foundAny = false;
    var list = document.querySelectorAll('.machship-shipping-calculator.product__accordion.accordion');
    list.forEach(function (calc) {
      try { if (moveOne(calc)) foundAny = true; } catch (e) { /* swallow */ }
    });
    return foundAny;
  }

  // Main orchestrator: run now, then keep an eye out briefly for late injection
  function init() {
    // First attempt
    var moved = moveAll();

    // Short, bounded retry loop (handles apps injecting a bit later)
    var tries = 0;
    var maxTries = 20;          // ~2s total
    var interval = 100;         // ms

    var t = setInterval(function () {
      if (moveAll()) moved = true;
      tries++;
      if (tries >= maxTries) clearInterval(t);
    }, interval);

    // Observe the DOM for dynamic inserts (modals, quick views, app mounts)
    var obs;
    try {
      obs = new MutationObserver(function (mutations) {
        var touched = false;
        for (var i = 0; i < mutations.length; i++) {
          var m = mutations[i];
          for (var j = 0; j < m.addedNodes.length; j++) {
            var node = m.addedNodes[j];
            if (!(node instanceof Element)) continue;
            if (
              node.matches?.('.machship-shipping-calculator.product__accordion.accordion') ||
              node.querySelector?.('.machship-shipping-calculator.product__accordion.accordion')
            ) {
              touched = true;
              break;
            }
          }
          if (touched) break;
        }
        if (touched) moveAll();
      });

      obs.observe(document.documentElement || document.body, { childList: true, subtree: true });

      // Auto-disconnect after 8s to avoid observing forever
      setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 8000);
    } catch (e) {
      // MutationObserver not available or failed—silently ignore
    }

    // Handle Theme Editor section reloads (so it works in Customize)
    document.addEventListener('shopify:section:load', moveAll);
    document.addEventListener('shopify:section:reorder', moveAll);
    document.addEventListener('shopify:section:unload', moveAll);
  }

  // Start when DOM is ready (defensive)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ------------------------------------------------------------
// Part 2: Sticky syncing — keep calculator fixed under metas
// ------------------------------------------------------------
(function () {
  'use strict';

  var DESKTOP_MIN = 1024; // px; adjust to match your theme breakpoint
  var GAP_PX = 12;        // space between metas and calculator when sticky

  function els() {
    return {
      metas: document.querySelector('.product-single__metas.wishlist'),
      calc: document.querySelector('.machship-shipping-calculator.product__accordion.accordion')
    };
  }

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function makeSpacerFor(el) {
    if (el.__spacer) return el.__spacer;
    var s = document.createElement('div');
    s.style.width = '100%';
    s.style.height = el.offsetHeight + 'px'; // reserve current height
    el.__spacer = s;
    return s;
  }

  function ensureSpacerHeight(el) {
    if (!el.__spacer) return;
    el.__spacer.style.height = el.offsetHeight + 'px';
  }

  function fixCalcBelowMetas(metas, calc) {
    var rect = metas.getBoundingClientRect();
    var top = rect.top + metas.offsetHeight + GAP_PX;
    var left = rect.left + window.scrollX;
    var width = metas.offsetWidth;

    // add spacer so layout doesn't jump when calc becomes fixed
    if (!calc.__spacer && calc.parentNode) {
      var spacer = makeSpacerFor(calc);
      calc.parentNode.insertBefore(spacer, calc);
    } else {
      ensureSpacerHeight(calc);
    }

    calc.style.position = 'fixed';
    calc.style.top = top + 'px';
    calc.style.left = left + 'px';
    calc.style.width = width + 'px';
    calc.style.maxWidth = width + 'px';
    calc.style.zIndex = '1000';
    calc.__isFixed = true;
  }

  function unfixCalc(calc) {
    if (!calc) return;
    calc.style.position = '';
    calc.style.top = '';
    calc.style.left = '';
    calc.style.width = '';
    calc.style.maxWidth = '';
    calc.style.zIndex = '';
    calc.__isFixed = false;

    if (calc.__spacer && calc.__spacer.parentNode) {
      calc.__spacer.parentNode.removeChild(calc.__spacer);
    }
    calc.__spacer = null;
  }

  function metasIsFixed(metas) {
    if (!metas) return false;
    // Use computed style so it works whether added via class or inline style
    var cs = window.getComputedStyle(metas);
    return cs.position === 'fixed';
  }

  function syncSticky() {
    var refs = els();
    var metas = refs.metas;
    var calc  = refs.calc;
    if (!metas || !calc) return;

    // Only sync on desktop; revert on mobile
    if (!isDesktop()) {
      if (calc.__isFixed) unfixCalc(calc);
      return;
    }

    if (metasIsFixed(metas)) {
      fixCalcBelowMetas(metas, calc);
    } else {
      if (calc.__isFixed) unfixCalc(calc);
    }
  }

  // Run on load, scroll, resize
  function setupStickySync() {
    syncSticky();

    var throttled = false;
    function onScrollOrResize() {
      if (throttled) return;
      throttled = true;
      requestAnimationFrame(function () {
        throttled = false;
        syncSticky();
      });
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    // Watch for attribute/style/class changes that toggle stickiness
    var metas = document.querySelector('.product-single__metas.wishlist');
    if (metas && window.MutationObserver) {
      var obs = new MutationObserver(function () { syncSticky(); });
      obs.observe(metas, { attributes: true, attributeFilter: ['style', 'class'] });
    }

    // Re-sync when theme sections re-render in the editor
    document.addEventListener('shopify:section:load', syncSticky);
    document.addEventListener('shopify:section:reorder', syncSticky);
  }

  // Ensure relocate ran first; then set up sticky sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupStickySync);
  } else {
    // Slight delay so any late DOM moves are done
    setTimeout(setupStickySync, 0);
  }
})();



